// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_jg-0";